const moment = require('moment');
export class Post {
    constructor() {
        this.name = '';
        //@ts-ignore
        this.published_on = moment().format('YYYY-MM-DDTHH:mm:ss');
        this.is_published = false;
        this.categories = [];
        this.content = [];
        this.photos = [];
        this.slug = '';
        this.rows = [];
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/store/Models/Post.ts
// module id = null
// module chunks = 